import "babel-polyfill";
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();
import Vue from 'vue';
import $ from 'jquery';
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'bootstrap';
import config from '@/config'
import swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import { quillEditor } from 'vue-quill-editor';
import Mock from './mock/mock';
import axios from 'axios'
import echarts from 'echarts'

Vue.prototype.$echarts = echarts

Mock.mockData();
Vue.config.productionTip = false
// 全局注册应用配置
Vue.prototype.$config = config
// 全局注册校验方法
Vue.prototype.$validate = validate
Vue.use(ElementUI);
Vue.prototype.$http = axios;

// 自定义校验规则
import validate from  'validate'

import store from './store'

new Vue({
  router,
  vuetify,
  $,
  store,
  render: h => h(App)
}).$mount('#app')
